import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  CorporateRoleDto,
  CorporateRolesParameters,
  CreateCorporateRoleDto,
  PagedResultDto,
  UpdateCorporateRoleDto
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CorporateRolesService {
  private readonly baseUrl = '/api/Corporate-roles';
  private readonly http = inject(HttpClient);

  getAll(
    parameters?: CorporateRolesParameters
  ): Observable<PagedResultDto<CorporateRoleDto>> {
    const params = HttpHelper.toHttpParams(parameters ?? {});
    return this.http.get<PagedResultDto<CorporateRoleDto>>(`${this.baseUrl}`, {
      params
    });
  }

  create(
    corporationId: string,
    requestBody: CreateCorporateRoleDto
  ): Observable<void> {
    const params = HttpHelper.toHttpParams({ corporationId });
    return this.http.post<void>(`${this.baseUrl}`, requestBody, { params });
  }

  get(id: string): Observable<CorporateRoleDto> {
    return this.http.get<CorporateRoleDto>(`${this.baseUrl}/${id}`);
  }

  update(
    id: string,
    requestBody: UpdateCorporateRoleDto
  ): Observable<CorporateRoleDto> {
    return this.http.put<CorporateRoleDto>(
      `${this.baseUrl}/${id}`,
      requestBody
    );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getPermissions(id: string): Observable<CorporateRoleDto> {
    return this.http.get<CorporateRoleDto>(`${this.baseUrl}/${id}/permissions`);
  }

  getByCorporation(corporationId: string): Observable<CorporateRoleDto[]> {
    return this.http.get<CorporateRoleDto[]>(
      `${this.baseUrl}/by-corporation/${corporationId}`
    );
  }

  getDefaults(): Observable<CorporateRoleDto[]> {
    return this.http.get<CorporateRoleDto[]>(`${this.baseUrl}/defaults`);
  }

  search(
    parameters?: CorporateRolesParameters
  ): Observable<PagedResultDto<CorporateRoleDto>> {
    const params = HttpHelper.toHttpParams(parameters ?? {});
    return this.http.get<PagedResultDto<CorporateRoleDto>>(
      `${this.baseUrl}/search`,
      { params }
    );
  }
}
